// extracted by mini-css-extract-plugin
export var button = "BlogAuthor-module--button--c9277";
export var content = "BlogAuthor-module--content--e706e";
export var description = "BlogAuthor-module--description--00658";
export var image = "BlogAuthor-module--image--d5181";
export var name = "BlogAuthor-module--name--98042";
export var role = "BlogAuthor-module--role--50f28";
export var root = "BlogAuthor-module--root--8276a";
export var texts = "BlogAuthor-module--texts--15172";
export var title = "BlogAuthor-module--title--e827b";
export var topDivider = "BlogAuthor-module--top-divider--1a829";